import styled from 'styled-components';
import {
  body2,
  body2Medium,
  borderRadius,
  caption,
  colors,
  fontSizes,
  overline,
  spacing,
} from 'ui/theme';
import { Toggletip } from 'ui/tooltip/Toggletip';

export const EllipsizedItem = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const SelectGroupHeader = styled.div`
  ${overline};
  color: ${colors.textDisabled};
  text-transform: uppercase;
  margin: 0;
  padding: ${spacing.threeEights} 0;
`;

export const SelectGroupWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  margin: 0 -${spacing.quarter} ${spacing.quarter};
  justify-content: space-between;
  &&[data-show-category-divider="true"]:not([data-category-index="0"]) {
    padding-top: ${spacing.base};
  }
  &&[data-show-category-divider="false"]:not([data-category-index="0"]) {
    padding-top: calc(${spacing.base}/2);
  }
`;

export const SelectGroupDivider = styled.hr`
  all: unset;
  padding: 0;
  margin: ${spacing.half} 0;
  top: 0;
  left: calc(-${spacing.plusThreeQuarter} / 2);
  position: absolute;
  height: 1px;
  width: calc(100% + ${spacing.plusThreeQuarter});
  border-top: 1px solid ${colors.borderPrimarySubtle};
`;

export const SelectCompactItem = styled.span`
  ${body2};
  padding-right: ${spacing.quarter};
  &[data-disabled="true"] {
    color: ${colors.textDisabled};
  }
`;

export const SelectCompactItemCount = styled.div`
  ${body2};
  border-radius: ${borderRadius.md};
  background-color: ${colors.backgroundSecondary};
  border: 1px solid ${colors.borderPrimary};
  padding: ${spacing.eighth} ${spacing.half};
  display: flex;
  align-items: center;
  gap: ${spacing.quarter};
  &[data-disabled="true"] {
    background-color: ${colors.backgroundDisabled};
    color: ${colors.textDisabled};
  }
`;

export const SelectErrorMsg = styled.div`
  ${caption};
  padding-top: ${spacing.quarter};
  display: flex;
  gap: ${spacing.quarter};
  color: ${colors.textDestructive};
`;

export const SelectOptionValue = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${spacing.eighth};
  width: 100%;
`;

export const SelectOptionInnerWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
`;

export const SelectIconWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const Description = styled.div`
  ${body2};
  font-size: ${fontSizes.s12};
  line-height: ${fontSizes.s16};
  color: ${colors.textSecondary};

  // moves description to align with text rather than checkbox in multi
  &[data-multi="true"] {
    padding-left: ${spacing.double};
  }
`;

export const SecondaryText = styled.div`
  ${body2}
  color: ${colors.textSecondary};
`;

export const DefaultCreateLabelWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  column-gap: ${spacing.quarter};
`;

export const LabelWithoutCheckbox = styled.div`
  ${body2Medium};
  color: ${colors.textPrimary};
  user-select: none;
  margin-bottom: 0;
`;

export const OptionLimitContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledToggleTip = styled(Toggletip)`
  width: 100%;
`;

export const OptionList = styled.div`
  height: 100%;
  width: 100%;
  position: relative;
`;

export const VirtualizedOptionListItem = styled.div`
  top: 0;
  left: 0;
  width: 100%;
  position: absolute;
`;

export const LoadingOptionsListItem = styled.div`
  color: ${colors.textSecondary};
  padding: ${spacing.half};
`;
